import APP_ENTRIES, {type AppEntry} from '@/consts/appEntries';
import {UWM_INIT_MARKET_LOCALE} from '@/consts/eventTypes';
import type {BadgesData} from '@/types/loyalty/badgesData';
import type {RewardsData} from '@/types/loyalty/rewardsData';
/* import completedBadgeMock from '../../../../mock/completed_badge.json'; */

type MockEventPayload = Record<string, unknown>;

const _dispatchCustomEvent = (command: string, payload: MockEventPayload) => {
    if (!command) {
        return undefined;
    }

    const customEvent = new CustomEvent('mockCommand', {
        detail: {
            command,
            payload,
        },
    });
    document.dispatchEvent(customEvent);
};

const dispatchMarketLocaleEvent = (payload: {
    marketCode?: string;
    languageCode?: string;
    entry?: AppEntry;
    badgesConfiguration?: BadgesData;
    rewardsConfiguration?: RewardsData;
}) =>
    _dispatchCustomEvent(UWM_INIT_MARKET_LOCALE, {
        marketCode: payload.marketCode ?? 'uat',
        languageCode: payload.languageCode ?? 'en',
        ...(payload.entry !== undefined && {entry: payload.entry}),
        ...(payload.badgesConfiguration !== undefined && {badgesConfiguration: payload.badgesConfiguration}),
        ...(payload.rewardsConfiguration !== undefined && {rewardsConfiguration: payload.rewardsConfiguration}),
    });

const dispatchers = {
    dispatchMarketLocaleEvent,
};

// @ts-expect-error
window.dispatchers = dispatchers;

/* setTimeout(
    () =>
        dispatchMarketLocaleEvent({
            marketCode: 'gbv2',
            languageCode: 'en',
            entry: APP_ENTRIES.BADGES,
            badgesConfiguration: completedBadgeMock as unknown as BadgesData,
        }),
    500
);
 */
export default dispatchers;